import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'website';
const pagePrefix = 'admin';
const action = 'CustomPageButtonInteracted';

const actionProps = {
  action,
  category,
  pagePrefix,
};

const telemObject = createTelemetryObject({
  actions: {
    uploadPhotoClicked: (page: string, purpose: 'add' | 'replace') => ({
      ...actionProps,
      page,
      label: 'Upload Photo Clicked',
      extraInfo: {
        itemType: 'photo',
        purpose,
      },
    }),
  },
});

const { TelemetryProvider: WebsiteEditorPhotoTelemetryProvider, useTelemetry: useWebsiteEditorPhotoTelemetry } = createTelemetry(telemObject);

export { WebsiteEditorPhotoTelemetryProvider, useWebsiteEditorPhotoTelemetry };
